<template>
  <div>
    <button v-tooltip="tooltipText" class="b-btn  b-import__choose-btn" @click="isShowBtnDropdown = !isShowBtnDropdown">
      <dynamic-icon class="b-btn__icon" :icon="iconName"/>
      {{btnText}}
    </button>
    <transition name="fade">
      <div v-if="importData">
        <div class="b-import__choose-list" v-if="isShowBtnDropdown">
          <ul>
            <li class="b-import__choose-list-item" v-for="item in importData" @click="setChooseValue(item.value)">
              {{item.text}}
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
	export default {
		props: {
			importData: {
				required: false,
      },
			btnText: {
				required: true,
        type: String,
      },
			iconName: {
				type: String,
      },
      tooltipText: {
        type: String,
        required: false
      }
    },
		data() {
			return {
				isShowBtnDropdown: false,
			}
		},
    methods: {
			setChooseValue(value) {
        this.$emit('onChooseValue', value);
        this.isShowBtnDropdown = false;
      }
    }
	}
</script>

